import React from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../config";
import { useI18n } from "../i18n/I18nProvider";

function PortfCard({ project }) {
  const { t } = useI18n();

  return (
    <div className="col-md-4">
      <div className="container_main">
        {project.images && project.images.length > 0 && (
          <img
            src={`${API_URL}${project.images[0]}`}
            alt={`${t("portfolio.imageAlt")} — ${project.name_site}`}
            className="image"
          />
        )}
        <div className="overlay">
          <div className="text">
            <div className="btn_main">
              <h3
                className="banner_text"
                style={{ fontWeight: "bolder" }}
              >
                {project.name_site}
              </h3>
              <div className="buy_bt">
                <Link
                  to={`/portfolioDetails/${project.id}`}
                  className="see-more-link pro-btn pro-btn--primary"
                >
                  {t("portfolio.seeMore")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PortfCard;
